import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { providerApiClient } from '@/lib/api'
import { settingsKeys } from '@/lib/queryKeys'
import type { ProviderProfile } from '@/types/settings'

export function useProviderProfile() {
  return useQuery({
    queryKey: settingsKeys.providerProfile(),
    queryFn: () => providerApiClient.getProviderProfile(),
    staleTime: 5 * 60 * 1000,
  })
}

export function useUpdateProviderProfile() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: ProviderProfile) => providerApiClient.updateProviderProfile(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: settingsKeys.providerProfile() })
    },
  })
}
